// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1jLTo","info":"Note_info__NPcUB","note":"Note_note__2p5gO","actions":"Note_actions__3b7kr"};